import { PartState } from '../types';
import { lookingRightState } from './looking-right';

/**
 * Pointing right state — Bizy looking right with right arm extended
 * straight out to the right, pointing in that direction.
 */
export const pointingRightState: PartState = {
	...lookingRightState,
	arms: [
		// Left arm hangs down naturally
		lookingRightState.arms[0],
		// Right arm pointing straight out to the right
		{ d: 'M201 135L218 130C224 128 230 124 234 122L240 119', side: 'right' },
	],
};
